import React__default from 'react';
import { Card, Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const Reorder = ({ id , isReorderAvailable , onReorder  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React__default.createElement(Card.Section, {
        className: "reorder"
    }, isReorderAvailable && onReorder ? /*#__PURE__*/ React__default.createElement(Card.Link, {
        iconBefore: "add-to-cart",
        onClick: ()=>onReorder(id)
        ,
        variant: "caption-head"
    }, intl.getLabel('cart.actions.addToCart')) : /*#__PURE__*/ React__default.createElement(Card.Section, {
        className: "reorder__unavailable"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        component: "span",
        variant: "caption",
        color: "text-secondary"
    }, intl.getLabel('account.reorder.notReorderable')), /*#__PURE__*/ React__default.createElement(Tooltip, {
        id: `reorder-${id.replace(/ /g, '').toLowerCase()}`,
        placement: "auto",
        message: intl.getLabel('account.reorder.notReorderable.tooltip')
    })));
};
var Reorder$1 = Reorder;

export { Reorder$1 as default };
//# sourceMappingURL=Reorder.js.map
